import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const marketing: Step = {
    id: OnboardingFlows.Marketing,
    showCondition: {
        stepId: OnboardingFlows.UseCases,
        selectedOption: 'Marketing',
    },
    title: 'What materials do you plan to create?',
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Video ads',
        },
        {
            label: 'Social media clips',
        },
        {
            label: 'Product guides',
        },
        {
            label: 'Video presentations',
        },
        {
            label: 'Interactive Avatars (Agents)',
        },
        {
            label: 'Internal and external communications',
        },
        {
            label: 'Email marketing',
        },
        {
            label: 'Localized content',
        },
    ],
};
